import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import CouponCard from "../../components/CouponCard";
import DatePicker from "../../components/DatePicker";
import PaddingContainer from "../../components/PaddingContainer";
import TabsContainer from "../../components/TabsContainer";
import { AddCircleIcon } from "../../constant";
import useDebounce from "../../customHooks/useDebounce";
import AreYouSureModal from "../../modals/AreYouSureModal";
import AddOrEditCouponsModal from "../../modals/Coupons/AddOrEditCouponsModal";
import { setPageLink, setPageTitle } from "../../store/pageSlice";
import useApi from "../../useApi";
import classes from "./Coupons.module.css";
import Loader from "../../components/Loader";

const SmallHeading = ({ label }) => {
  return <h2 className={classes.smallHeading}>{label}</h2>;
};

const Coupons = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("")
  const [dateFilter, setDateFilter] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ])
  const { getAllCoupons, addCoupon, updateCoupon } = useApi();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showAddOrEitCouponModal, setShowAddOrEitCouponModal] =
    useState(false);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [coupons, setCoupons] = useState([]);

  const navbarActions = [
    // {
    //   label: "Add Coupon",
    //   type: "white",
    //   onClick: () => {
    //     setSelectedItem(null);
    //     setShowAddOrEitCouponModal(true);
    //   },
    //   icon: <AddCircleIcon />,
    // },
    // {
    //   label: "Add Coupon",
    //   type: "primary",
    //   onClick: () => {
    //     setSelectedItem(null);
    //     setShowAddOrEitCouponModal(true);
    //   },
    //   icon: <AddCircleIcon />,
    // },
    {
      label: "Add Coupon",
      type: "primary",
      onClick: () => {
        setSelectedItem(null);
        setShowAddOrEitCouponModal(true);
      },
      icon: <AddCircleIcon />,
    },
  ];
  const debounceSearch = useDebounce(search, 500);
  const getAllCouponsHandler = async (params) => {
    setLoading(true);
    const response = await getAllCoupons(params);
    if (response?.data?.headers?.error === 200) {
      setCoupons(response?.data?.body?.items?.filter(item => item?.active));
    } else {
      toast.error(response?.data?.headers?.message);
    }
    setLoading(false);
  };
  const addCouponHandler = async (params) => {
    setLoading(true);
    const res = await addCoupon(params);
    if (res?.data?.headers?.error === 200) {
      toast.success("Coupon Added Successfully");
      setCoupons((prev) => [res?.data?.body, ...prev]);
      setShowAddOrEitCouponModal(false);
    }
    else {
      toast.error(res?.data?.headers?.message);
    }
    setLoading(false);
  };

  const updateCouponHandler = async (params) => {
    setLoading(true);
    const res = await updateCoupon(params);
    if (res?.data?.headers?.error === 200) {
      toast.success(
        `Coupon ${params?.delete ? "Deleted" : "Updated"} Successfully`
      );
      setCoupons((prev) => {
        if (params?.delete) {
          return prev.filter((item) => item.couponId !== params.couponId);
        } else {
          return prev.map((item) =>
            item.couponId === params.couponId ? params : item
          );
        }
      });
      setShowAddOrEitCouponModal(false);
      setShowAreYouSureModal(false);
    }
    setLoading(false);
  };

  const onDeleteCoupon = (data) => {
    setShowAreYouSureModal(true);
    setSelectedItem(data);
  };

  useEffect(() => {
    getAllCouponsHandler({
      id: null,
      search: debounceSearch,
      pageNumber: 1,
      pageSize: 100000000,
      showInactive: true,
      showUpcoming: true,
    });
  }, [debounceSearch]);

  useEffect(() => {
    dispatch(setPageTitle("Coupons"));
    dispatch(setPageLink(""));
  }, []);

  const onEditCoupon = (data) => {
    setSelectedItem(data);
    setShowAddOrEitCouponModal(true);
  };

  return (
    <>
      {
        loading ? <Loader /> :
          <>

            <PaddingContainer>
              <div className={classes.wrapper}>
                <nav className={classes.couponsHeader}>
                  <h1 className={classes.title}>List of Coupons</h1>
                  <TabsContainer
                    tabs={
                      <>
                        <div className={classes.navbarActions}>
                          {/* <SearchInput value={search} onChange={setSearch} placeholder="Search Coupon" /> */}

                          {navbarActions?.map(
                            ({ type, label, variant, icon, onClick }) => {
                              return (
                                <Button
                                  variant={type}
                                  className={classes.headerBtn}
                                  leftIcon={icon}
                                  label={label}
                                  onClick={onClick}
                                />
                              );
                            }
                          )}
                        </div>
                        <DatePicker
                          type="range"
                          value={dateFilter}
                          onChange={(e) => setDateFilter(e)}
                        />
                      </>
                    }
                  />
                </nav>

                <section className={classes.couponsList}>
                  <SmallHeading label="Recently Added" />
                  <Row>
                    {coupons?.map((coupon) => (
                      <Col key={coupon?.couponId} xs={12} md={6} lg={4}>
                        <CouponCard
                          onDelete={onDeleteCoupon}
                          onEdit={onEditCoupon}
                          coupon={coupon}
                        />
                      </Col>
                    ))}
                  </Row>
                </section>
                <section className={classes.couponsList}>
                  <SmallHeading label="All Coupons" />
                  <Row>
                    {coupons?.map((coupon) => (
                      <Col key={coupon?.couponId} xs={12} md={6} lg={4}>
                        <CouponCard
                          onDelete={onDeleteCoupon}
                          onEdit={onEditCoupon}
                          coupon={coupon}
                        />
                      </Col>
                    ))}
                  </Row>
                </section>
              </div>
            </PaddingContainer>

            {showAddOrEitCouponModal && (
              <AddOrEditCouponsModal
                data={selectedItem}
                onEdit={onEditCoupon}
                show={showAddOrEitCouponModal}
                setShow={setShowAddOrEitCouponModal}
                onSubmit={selectedItem ? updateCouponHandler : addCouponHandler}
              />
            )}
            {showAreYouSureModal && (
              <AreYouSureModal
                title="Coupon"
                data={selectedItem?.couponName}
                show={showAreYouSureModal}
                setShow={setShowAreYouSureModal}
                onConfirm={() => {
                  updateCouponHandler({
                    "couponId": selectedItem?.couponId,
                    "couponAddress": null,
                    "couponCity": null,
                    "couponCountry": null,
                    "countryCode": null,
                    "cellNumber": null,
                    "delete": true
                  })
                }}
              />
            )}
          </>
      }
    </>
  );
};

export default Coupons;
